module.exports = __webpack_public_path__ + "img/mp_logo.e3369f7a.png";